import React from 'react';
import { motion } from 'framer-motion';

const experiences = [
  {
    role: 'Underviser - presse- og mediehåndtering',
    company: 'Sundhedsstyrelsen',
    description: 'Underviser kommende speciallæger i pressehåndtering, medietræning og strategisk kommunikation.',
    year: '2025 - NU',
    current: true
  },
  {
    role: 'Chefredaktør',
    company: 'Netdoktor Media',
    description: 'Transformering af siden til et moderne digitalt sundhedsmedie. Ansvarlig for markant øget SEO-trafik og strategisk ledelse af 18 medarbejdere.',
    year: 'SENEST',
  },
  {
    role: 'Chief Business Developer',
    company: 'Aller Media',
    description: 'Nøglespiller i den digitale transformation fra print til online. Opbygning af tværgående digitale redaktioner og implementering af nye forretningsmodeller.',
    year: 'ALLER',
  },
  {
    role: 'Opbygning af redaktion',
    company: 'Listen to News',
    description: 'Opbyggede redaktion, arbejdsprocesser og den daglige drift af en digital nyhedspodcast.',
    year: 'PODCAST',
  },
  {
    role: 'Projektleder (Digital)',
    company: 'Danmarks Radio',
    description: 'Ansvarlig for implementering af nyt CMS og nye arbejdsgange i DR Nyheder og DR Undervisning.',
    year: 'DR',
  },
  {
    role: 'Redaktør',
    company: 'Danmarkshistorien',
    description: 'Redaktionelt ansvar for dokumentarserien om Besættelsen (30 afsnit).',
    year: 'TV',
  }
];

const Experience = () => {
  return (
    <section id="erfaring" className="py-32 bg-stone-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        
        {/* Section Header */}
        <div className="mb-24 text-center">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl font-black text-slate-900 tracking-tight sm:text-5xl"
          >
            Karrierehøjdepunkter
          </motion.h2>
          <motion.div 
             initial={{ width: 0 }}
             whileInView={{ width: 100 }}
             viewport={{ once: true }}
             className="h-1.5 bg-slate-900 mx-auto mt-6"
          />
        </div>

        <div className="relative">
          {/* Vertical Timeline Line */}
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-slate-200 -translate-x-1/2 hidden md:block" />

          <div className="space-y-12 md:space-y-24">
            {experiences.map((exp, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.7, delay: index * 0.1 }}
                className={`relative flex flex-col md:flex-row items-center ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`}
              >
                {/* Timeline Dot */}
                <div className="absolute left-4 md:left-1/2 w-4 h-4 rounded-full bg-slate-900 border-4 border-white shadow-sm -translate-x-1/2 z-10 hidden md:block" />

                {/* Content Card */}
                <div className="w-full md:w-[45%]">
                  <div className={`p-8 bg-white rounded-3xl shadow-sm border border-stone-100 hover:shadow-xl hover:border-slate-200 transition-all duration-500 group ${exp.current ? 'ring-2 ring-slate-900 ring-offset-4' : ''}`}>
                    <div className="flex items-center gap-3 mb-4">
                      <span className="px-3 py-1 bg-slate-100 text-[10px] font-black uppercase tracking-widest text-slate-500 rounded-full group-hover:bg-slate-900 group-hover:text-white transition-colors">
                        {exp.year}
                      </span>
                    </div>
                    <h3 className="text-2xl font-bold text-slate-900 mb-1">{exp.role}</h3>
                    <h4 className="text-lg font-medium text-slate-400 mb-4">{exp.company}</h4>
                    <p className="text-slate-600 leading-relaxed font-light italic">
                      "{exp.description}"
                    </p>
                  </div>
                </div>

                {/* Spacer for flow */}
                <div className="hidden md:block w-[10%]" />
                <div className="hidden md:block w-[45%]" />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;